import { paginationStateAtom } from "components/screener/v2/PaginationControls";
import { Badge } from "components/ui/Badge";
import { TextTooltip } from "components/ui/Tooltip";
import { useAtomValue } from "jotai";
import { FormattedMessage, useIntl } from "react-intl";

export const TotalOfRows = () => {
  const intl = useIntl();
  const pagination = useAtomValue(paginationStateAtom);
  if (pagination === null) {
    return null;
  }
  const canDisplayRowsInGrid = !!(
    pagination.totalRows &&
    pagination.totalRows > pagination.rowsInGrid &&
    pagination.rowsInGrid > 0
  );
  return (
    <TextTooltip
      asChild={true}
      side="top"
      align="start"
      delayDuration={1000}
      contentClassName="font-bold"
      content={intl.formatMessage({
        defaultMessage: "Quantidade de linhas em exibição + número de ativos disponíveis para paginar",
        id: "+sS8xN",
      })}
    >
      <Badge variant="slate" className="inline-flex gap-x-1 rounded-md">
        {canDisplayRowsInGrid && (
          <>
            <FormattedMessage
              id="wAH9dS"
              defaultMessage="{totalCount, plural, one {# linha} other {# linhas}}"
              values={{ totalCount: pagination.rowsInGrid }}
            />
            <span>/</span>
          </>
        )}
        <FormattedMessage
          id="CIsaNe"
          defaultMessage="{totalCount, plural, =0 {Sem resultados} one {# ativos} other {# ativos}}"
          values={{ totalCount: pagination?.totalRows || 0 }}
        />
      </Badge>
    </TextTooltip>
  );
};
